import styled from 'styled-components';

export const SubHeader = styled.div`
  padding: 1rem 1rem;
  display: flex;
  align-items: flex-start;
`;
